var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGender({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1255 16.5V22.5M12.7505 19.5H7.50049M20.2505 5.25V1.5M20.2505 1.5H16.5005M20.2505 1.5L15.7167 6.03375",
    stroke: "#5C5CAB",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1245 15.75C13.6453 15.75 16.4995 12.8958 16.4995 9.37503C16.4995 5.85422 13.6453 3.00003 10.1245 3.00003C6.6037 3.00003 3.74951 5.85422 3.74951 9.37503C3.74951 12.8958 6.6037 15.75 10.1245 15.75Z",
    stroke: "#5C5CAB",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.b68aaedb72b700688bfb3a27fe0efa34.svg";
export { ForwardRef as ReactComponent };